import { withTranslations } from '@/utils/Language';
import tagsEn from '@/assets/i18n/tags/en.json';

const enDefault = { ...tagsEn };

export default withTranslations(
  (lang) => Promise.all([import(`@/assets/i18n/tags/${lang}.json`)]).then(([tags]) => ({ ...tags.default })),
  enDefault
);
